<template>
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-project @node-click="nodeClick"></erp-project>
  </div>
  <div class="d-flex-right" v-if="dades.pindex_id">
    <div>
      <!-- <el-button size="mini" type="primary text2"  @click="modalsa" v-if="ERP.isPermission(4004005001)">设置费用</el-button> -->
      <el-button size="mini" type="primary text2"  @click="modals" v-if="ERP.isPermission(4004005002)">导入费用</el-button>
      <el-button size="mini" type="primary text2"  @click="modalsxz" v-if="ERP.isPermission(4004005003)">电费模板</el-button>
      <el-button size="mini" type="primary text2"  @click="modalsxzs" v-if="ERP.isPermission(4004005003)">水费模板</el-button>
      <el-button size="mini" type="primary text2"  @click="modalsxzss" v-if="ERP.isPermission(4004005003)">动态模板</el-button>
      <el-input size="mini" class="search" placeholder="请输入搜索名称" v-model="search" clearable></el-input>
      <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
    </div>
    <div>位置：{{company_name}}-{{jname}}-{{name}}</div>
    <v-divider></v-divider>
    <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">ID</th>
          <th class="text-left">缴费名称</th>
          <th class="text-left">项目</th>
          <th class="text-left">类型</th>
          <th class="text-left">创建人</th>
          <th class="text-left">导入日期</th>
          <th class="text-left">操作</th>
        </tr>
        </thead>
        <tbody
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)">
        <tr class="text1" v-for="item in desserts" :key="item.id">
          <td >{{item.id}}</td>
          <td >{{item.name}}</td>
          <td >{{name}}</td>
          <td >住宅</td>
          <td >{{item.user}}</td>
          <td >{{item.date}}</td>
          <td class="cdj_td">
            <div v-if="ERP.isPermission(4004005004)">
              <div  style="color: #1867c0;cursor: pointer;" @click="xiaz( item.url )">下载</div>
            </div>
            <div v-if="item.seasc != 1 && ERP.isPermission(4004005005)">
              <div style="color: #1867c0;margin-left: 5px;cursor: pointer;" @click="shengc( item.id,item.type )">生成账单</div>
            </div>
            <div v-if="ERP.isPermission(4004005006)">
              <div style="color: red;margin-left: 5px;cursor: pointer;" @click="del( item.id )">删除</div>
            </div>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
    <Modal
      v-model="modal123"
      ok-text="下载"
      width="800"
      title="下载动态费用模板"
      @on-ok="okdtai">
      <el-form  label-width="100px" :model="dades">
        <el-form-item label="选择收费项">
          <el-select v-model="value3" filterable placeholder="选择收费项">
            <el-option
              v-for="item in options1"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </Modal>
    <Modal
      v-model="modal12"
      :ok-text="anxiu"
      width="800"
      title="设置水电费费用"
      @on-ok="oks">
      <el-form  label-width="100px" :model="dades">
        <span class="text">每度电多少费用（单位元）</span>
        <el-form-item label="电费设置" :rules="[{required: true}]">
          <el-input v-model="forms.dianfei"></el-input>
        </el-form-item>
        <span class="text">每立方多少费用(下载模板，填写抄表读数1，为1立方)（单位元）</span>
        <el-form-item label="水费设置" :rules="[{required: true}]">
          <el-input v-model="forms.shuifei"></el-input>
        </el-form-item>
      </el-form>
    </Modal>
    <Modal
      v-model="modal1"
      :ok-text="anxiu"
      width="800"
      title="编辑收费项"
      @on-ok="ok">
      <el-form  label-width="100px" :model="dades">
        <el-form-item label="缴费名称" :rules="[{required: true}]">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="费用类型" :rules="[{required: true}]">
          <el-select style="width: 100%;" v-model="form.types" filterable placeholder="请选择">
            <el-option
              v-for="item in types"
              :key="item.id"
              :label="item.chargeItem_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="绑定收费项" :rules="[{required: true}]">
          <el-select style="width: 100%;" v-model="form.charge_id" filterable placeholder="请选择">
            <el-option
              v-for="item in chargeArr"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择类型" :rules="[{required: true}]">
          <el-select style="width: 100%;" v-model="form.type" placeholder="请选择类型">
            <el-option label="电费" value="1"></el-option>
            <el-option label="水费" value="2"></el-option>
            <el-option label="动态费用" value="3"></el-option>
            <!-- <div v-for="items in daorusdf" :key="items.id">
              <el-option :label="items.name" :value="items.id"></el-option>
            </div> -->
          </el-select>
        </el-form-item>
        <el-form-item label="计费周期" :rules="[{required: true}]">
          <el-date-picker
            v-model="datevalue"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="上传文件">
          <el-upload
            class="upload-demo"
            :action="url"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :on-success="handleAvatarSuccess"
            accept=".xls,.xlsx"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :before-upload="beforeAvatarUpload">
            <el-button size="small" type="primary" class="texts">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls或xlsx文件，且不超过7M</div>
          </el-upload>
        </el-form-item>
      </el-form>
    </Modal>
  </div>
</div>

</template>

<script>
import ErpProject from "../Common/erp-project";
export default {
  name: 'pindexAllocations',
  components: {ErpProject},
  data () {
    return {
      url:'',
      dades:{
          id:'',
          name:'',
          pindex_id:'',
          type:'',
          remarks:'',
      },
      form:{
        name:'',
        pindex_id:'',
        type:'',
        route:'',
        types:'',
        charge_id:'',
        startDate:'',
        endDate:'',
      },
      options1:[{
        id:'',
        name:'',
      }],
      forms:{
          pindex_id:'',
          dianfei:'',
          shuifei:'',
      },
      types:[],
      options: [],
      cfx:[],
      id:'',
      company_name:'',
      jname:'',
      name:'',
      options2:[],
      value: [],
      value1:'',
      value3:'',
      input1: '',
      desserts: '',
      cs:'',
      daorusdf:'',
      csa:1,
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      modal1: false,
      loading:false,
      modal12:false,
      modal123:false,
      props: {
          label: 'name',
          children: 'zones',
          isLeaf: 'leaf'
      },
      urls:'',
      fileList: [],
      chargeArr:[],
      datevalue:[],
    }
  },
  //界面没出来前加载
  created() {

  },
  // 加载数据
  mounted(){
    var login = window.localStorage.getItem('login');
    var token = window.localStorage.getItem('token');
    this.url = this.$myhttp.defaults.baseURL + "/admin/excel"+"?login_name="+login+"&token="+token;
    this.id = this.$route.query.id;
    this.dades.pindex_id = this.id;
    this.form.pindex_id = this.id;
    this.forms.pindex_id = this.id;
    this.company_name = this.$route.query.company_name;
    this.jname = this.$route.query.jname;
    this.name = this.$route.query.name;

    // ERP.showLoading()
    // this.$Loading.start();
    // // console.log(this.id);
    // this.$myhttp.get('admin/allindex?id=1&aid='+this.id+"&search="+this.search,{
    //   'Content-Type': 'application/json'
    //   }).then(backdata=>{ // 异步执行成功后
    //     this.desserts = backdata.data[0];
    //     this.total = backdata.data[1];
    //     this.page = backdata.data[2];
    //     this.$Loading.finish();
    //   ERP.hideLoading()
    //   });
       this.$myhttp.get('admin/getChargeType',{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.types = backdata.data.data;
      });
    //加载公司列表和归属列表
    // this.$myhttp.get('admin/getcompany',{
    //   'Content-Type': 'application/json'
    //   }).then(backdata=>{ // 异步执行成功后
    //     this.options = backdata.data[0];
    //     this.options1 = backdata.data[1];
    // });

  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
      //设置费用
      modalsa(){
        this.$Loading.start();
        this.modal12=true;
        this.$myhttp.get('admin/allxiugclass?pindex_id='+this.id,{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
            this.forms = backdata.data;
            this.$Loading.finish();
        });
      },
      //下载
      xiaz(e){
          this.urls = this.$myhttp.defaults.baseURL+"/storage/"+e;
          window.open(this.urls);
      },
      handleRemove(file, fileList) {
        // console.log(file, fileList);
      },
      handlePreview(file) {
        // console.log(file);
      },
      //超过一个文件
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      //删除
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      //限制大小
      beforeAvatarUpload(file){
        const isLt7M = file.size / 1024 / 1024 < 7;
        if (!isLt7M) {
          this.$message.error('上传文件大小不能超过 7MB!');
        }
        return isLt7M;
      },
      handleAvatarSuccess(res, file){
        this.form.route = file.response[0];
      },

      //下载电费模板
      modalsxz(){
        //   console.log(this.id)
        this.loading=true;
        this.$myhttp.get('admin/modalsxz?pindex_id='+this.id+"&type=57",{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
            this.loading=false
            // console.log(backdata.data);
            if(backdata.data==208){
              this.$Message.error('该项目还没有房产!');
              return false;
            }
            if(backdata.data!=206){
              let url = this.$myhttp.defaults.baseURL+"/storage/cdj/"+backdata.data.date+'/'+backdata.data.filename;
              window.open(url, '_blank');
            }
        });
      },
      //下载水费模板
      modalsxzs(){
        this.loading=true;
        this.$myhttp.get('admin/modalsxz?pindex_id='+this.id+"&type=56",{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
            this.loading=false
            if(backdata.data==208){
              this.$Message.error('该项目还没有房产!');
              return false;
            }
            // console.log(backdata.data);
            if(backdata.data!=206){
              let url = this.$myhttp.defaults.baseURL+"/storage/cdj/"+backdata.data.date+'/'+backdata.data.filename;
              window.open(url, '_blank');
            }
        });
      },
      //下载动态模板
      modalsxzss(){
        this.$myhttp.get('admin/dtaisfx?cid='+this.id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
            this.options1 = backdata.data[0];
        });
        // this.modal123=true;
        this.okdtai();
      },
      okdtai(){
        // if(this.value3 == ""){
        //    this.$Message.error('收费项不能为空!');
        //    return false;
        // }
        this.loading=true;
        this.$myhttp.get('admin/modalsxzsas?pindex_id='+this.id+"&type="+this.value3,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
            this.loading=false
            if(backdata.data!=208){
              let url = this.$myhttp.defaults.baseURL+"/storage/cdj/"+backdata.data.date+'/'+backdata.data.filename;
              window.open(url, '_blank');
            }else{
              this.$Message.error('该项目还没有房产!');
              return false;
            }
        });
      },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/allindex?id='+ e + '&search='+ this.search +'&aid='+this.id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //搜索
    searchs(){
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/allindex?search='+ this.search + '&id=1'+'&aid='+this.id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
      });
    },
    //保存
    ok(){
       if(this.form.name == ''){
          this.$Message.error('缴费名称不能为空!');
          return false;
       }
       if(this.form.pindex_id == ''){
          this.$Message.error('项目id为空了，请重新进入!');
          return false;
       }
       if(this.form.types == ''){
          this.$Message.error('费用类型不能为空!');
          return false;
       }
       if(this.form.charge_id == ''){
          this.$Message.error('收费项不能为空!');
          return false;
       }
       if(this.form.type == ''){
          this.$Message.error('选择类型不能为空!');
          return false;
       }

       let dates = this.datevalue;
       if(this.datevalue != null){
         if(dates.length > 0){
           var d = this.datevalue[0];//开始时间
           var e = this.datevalue[1];//结束时间
           this.form.startDate = new Date(d).getTime()/1000;
           this.form.endDate = new Date(e).getTime()/1000;
         }else{
           this.form.startDate = "";
           this.form.endDate = "";
         }
       }else{
         this.form.startDate = "";
         this.form.endDate = "";
       }

       if(this.form.startDate == ""){
         this.$Message.error('计费周期不能为空!');
         return false;
       }

       if(this.form.route == ''){
          this.$Message.error('上传文件不能为空!');
          return false;
       }
       this.loading = true;

       this.$myhttp.post('admin/modalsxzAdd',this.form,{
       'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
            this.$myhttp.get('admin/allindex?id=1&aid='+this.id+"&search="+this.search,{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
                this.desserts = backdata.data[0];
                this.total = backdata.data[1];
                this.page = backdata.data[2];
                this.loading = false;
                this.$Message.success("保存成功!");
                this.form={
                  name:'',
                  pindex_id:'',
                  type:'',
                  route:'',
                  types:'',
                  charge_id:'',
                  startDate:'',
                  endDate:'',
                };
                this.datevalue = [];
                this.form.pindex_id=this.id;
                this.fileList=[];
            });
        });
    },
    //保存水电费
    oks(){
        this.loading = true;
        this.$myhttp.post('admin/shuidianfeiAdd',this.forms,{
       'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
            this.loading = false;
            this.$Message.success('保存成功!');
        });
    },
    //绑定收费项,添加
    modals(){
        this.$set(this,'csa',1);
        this.modal1 = true;
        if(this.dades.id){
          this.dades.id = '';
          this.dades.name = '';
          this.dades.type = '';
          this.dades.remarks = '';
          this.value = [];
        }
        this.$myhttp.get('admin/getAllindexDT?cid='+this.id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
            this.daorusdf = backdata.data[0];
        });

        // console.log(this.id);
    },
    //生成订单
    shengc(e,type){
      let _this = this;
      this.$confirm('此操作将生成收费账单,只生成用量大于0的账单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          if(type>2){
            this.$myhttp.post('admin/allExecls',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
            //console.log(backdata.data);
                this.loading = false;
                if(backdata.data == 201){
                  this.loading = false;
                  this.$Message.error('生成失败!已经生成过费用');
                }
                if(backdata.data == 400){
                  this.loading = false;
                  this.$Message.error('生成失败!未设置水费费用');
                }
                if(backdata.data == 401){
                  this.loading = false;
                  this.$Message.error('生成失败!未设置电费费用');
                }
                if(backdata.data == 200){
                  this.loading = false;
                  this.$Message.success('生成订单成功!');
                }
                this.$myhttp.get('admin/allindex?search='+ this.search + '&id=1'+'&aid='+this.id,{
                  'Content-Type': 'application/json'
                  }).then(backdata=>{ // 异步执行成功后
                    this.desserts = backdata.data[0];
                    this.total = backdata.data[1];
                    this.page = backdata.data[2];
                });
            }).catch(function (error) {
              _this.$Message.error('生成失败');
              _this.loading = false;
            });
          }else{
            console.log(333);
            this.$myhttp.post('admin/allExecl',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              // console.log(backdata.data);
                if(backdata.data == 201){
                  this.loading = false;
                  this.$Message.error('生成失败!已经生成过费用');
                }
                if(backdata.data == 400){
                  this.loading = false;
                  this.$Message.error('生成失败!未设置水费费用');
                }
                if(backdata.data == 401){
                  this.loading = false;
                  this.$Message.error('生成失败!未设置电费费用');
                }
                if(backdata.data == 200){
                  this.loading = false;
                  this.$Message.success('生成订单成功!');
                }
                this.loading = false;
                this.$myhttp.get('admin/allindex?search='+ this.search + '&id=1'+'&aid='+this.id,{
                  'Content-Type': 'application/json'
                  }).then(backdata=>{ // 异步执行成功后
                    this.desserts = backdata.data[0];
                    this.total = backdata.data[1];
                    this.page = backdata.data[2];
                });
            }).catch(function (error) {
              _this.$Message.error('生成失败');
              _this.loading = false;
            });
          }
        })
    },
    //删除收费项
    del(e){
        this.$confirm('此操作将永久删除该项吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          this.$myhttp.post('admin/allDel',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data == 200){
                  this.$myhttp.get('admin/allindex?search='+ this.search + '&id=1'+'&aid='+this.id,{
                    'Content-Type': 'application/json'
                    }).then(backdata=>{ // 异步执行成功后
                    this.desserts = backdata.data[0];
                    this.total = backdata.data[1];
                    this.page = backdata.data[2];
                    this.loading=false;
                    this.$Message.success('删除成功!');
                 });
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    //绑定
    loadNode(node, resolve) {
        if (node.level === 0) {
          return resolve([{ name: 'region' }]);
        }
        if (node.level > 1) return resolve([]);

        setTimeout(() => {
          const data = [{
            name: 'leaf',
            leaf: true
          }, {
            name: 'zone'
          }];

          resolve(data);
        }, 500);
    },
    nodeClick(e){
      this.id=e.id;
      this.dades.pindex_id = this.id;
      this.form.pindex_id = this.id;
      this.forms.pindex_id = this.id;
      //查询
      this.$myhttp.get('admin/getOrganizations?pid='+this.id,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.company_name = backdata.data.data[0].company_name;
        this.jname = backdata.data.data[0].jname;
        this.name=backdata.data.data[0].name;
      });
      //收费项
      this.$myhttp.get('admin/chargeAllocations?pindex_id='+this.id,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.chargeArr = backdata.data.data;
      });
      this.change(1)
    }
  },
  watch: {
    '$route' (to, from) { //监听路由是否变化
      //加载项目
      if(to.path == "/pindex/Allocations"){
        this.id = this.$route.query.id;
        this.dades.pindex_id = this.id;
        this.company_name = this.$route.query.company_name;
        this.jname = this.$route.query.jname;
        this.name = this.$route.query.name;
        // console.log(this.id);
        if(this.id != undefined){
          this.$Loading.start();
          this.$myhttp.get('admin/allindex?id=1&aid='+this.id+"&search="+this.search,{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
              this.desserts = backdata.data[0];
              this.total = backdata.data[1];
              this.page = backdata.data[2];
              this.dades.type = '';
             this.$Loading.finish();
          });
        }else{
          this.desserts = [];
          this.total = 0;
          this.page = 0;
        }

      }
    },
    "form.types"(e){
      this.form.charge_id = "";
      //收费项
      this.$myhttp.get('admin/chargeAllocations?pindex_id='+this.dades.pindex_id +"&chargeitem_name="+e,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.chargeArr = backdata.data.data;
      });
      console.log(e)
    }

  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.kuan{
  width: 300px;
}
.text1{
  text-align: center;
}
.text{
    margin-left: 13%;
    color: rgb(214, 22, 86);
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhujie{
  margin-left: 12.7%;
  color: brown;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.el-button{
    color: rgb(252, 247, 247);
}
.item{
  margin-top: 1%;
}
.ys{
  color: brown;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/Allocations.vue